import { GroupPackaging } from '@shared/api/types';
import { HeaderCell } from '@shared/components/data-table/cells/header-cell';
import { PackagingRating } from '@shared/components/ratings/packaging-rating';
import { ColumnDef } from '@tanstack/react-table';
import {
  FilterOption,
  getLeadingColumns,
  getTrailingColumns,
} from './group-purchased-goods-columns';
import { GroupPackagingFilterColumn } from './group-packaging-table-filters';

interface UseColumnsArgs {
  ratingOptions: FilterOption[];
  supplierOptions: FilterOption[];
}

export function useGroupPackagingColumns({
  ratingOptions,
  supplierOptions,
}: UseColumnsArgs): ColumnDef<GroupPackaging>[] {
  return [
    ...getLeadingColumns<GroupPackaging>(),
    {
      id: GroupPackagingFilterColumn.Rating,
      accessorFn: (row) => row.carbonIntensityCategory,
      size: 80,
      header: ({ column }) => (
        <HeaderCell column={column} name="Rating" className="justify-center" />
      ),
      cell: ({ getValue }) => (
        <span className="col-span-2 flex justify-center">
          <PackagingRating
            category={getValue<GroupPackaging['carbonIntensityCategory']>()}
          />
        </span>
      ),
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        label: 'Rating',
        variant: 'multiSelect',
        options: ratingOptions,
        sorting: { ascLabel: 'Low-High', descLabel: 'High-Low' },
      },
    },
    ...getTrailingColumns<GroupPackaging>(),
    // Filter-only column. Hidden but registered with tanstack so the toolbar
    // can route faceted filter changes through it. (Search lives on the
    // visible Item column in `getLeadingColumns`.)
    {
      id: GroupPackagingFilterColumn.Supplier,
      accessorFn: () => null,
      enableColumnFilter: true,
      meta: {
        label: 'Supplier',
        variant: 'multiSelect',
        options: supplierOptions,
        sorting: { ascLabel: 'A-Z', descLabel: 'Z-A' },
      },
    },
  ];
}
